import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      login: {
        title: 'Admin Login',
        username: 'Username',
        password: 'Password',
        submit: 'Login',
        error: 'Invalid username or password'
      },
      nav: {
        dashboard: 'Dashboard',
        videos: 'Videos',
        stories: 'Stories',
        customers: 'Customers',
        categories: 'Categories',
        contacts: 'Contacts',
        admins: 'Administrators',
        logout: 'Logout'
      },
      dashboard: {
        title: 'Dashboard',
        overview: 'Overview',
        statistics: 'Statistics',
        totalUsers: 'Total Users',
        activeUsers: 'Active Users',
        totalVideos: 'Total Videos',
        activeVideos: 'Active Videos',
        totalStories: 'Total Stories',
        activeStories: 'Active Stories',
        videoViews: 'Video Views',
        storyViews: 'Story Views',
        categories: 'Categories',
        notificationsSent: 'Notifications Sent',
        recentActivity: 'Recent Activity',
        recentVideos: 'Recent Videos',
        recentStories: 'Recent Stories',
        viewsOverTime: 'Views Over Time (Last 30 Days)',
        contentByCategory: 'Content by Category',
        mostViewedVideos: 'Most Viewed Videos (Last 7 Days)',
        last30Days: 'Last 30 days',
        views: 'views',
        noData: 'No data available',
        loading: 'Loading dashboard...'
      },
      navigation: {
        contacts: 'Contacts'
      },
      customers: {
        title: 'Customers',
        add: 'Add Customer',
        addCustomer: 'Add Customer',
        editCustomer: 'Edit Customer',
        edit: 'Edit Customer',
        delete: 'Delete Customer',
        phone: 'Phone',
        email: 'Email',
        city: 'City',
        responsiblePerson: 'Responsible Person',
        notes: 'Notes',
        active: 'Active',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number',
        emailAddress: 'Email Address',
        personalInfo: 'Personal Information',
        contactInfo: 'Contact Information',
        additionalInfo: 'Additional Information',
        settings: 'Settings',
        sendWelcomeEmail: 'Send welcome email with login credentials',
        accountActive: 'Account Active',
        tempPasswordInfo: 'A temporary password will be automatically generated and sent to the customer\'s email address. The customer can change this password after their first login.',
        confirmDelete: 'Confirm Delete',
        deleteConfirmation: 'Are you sure you want to delete {name}? This action cannot be undone.',
        noCustomersFound: 'No customers found',
        name: 'Name',
        status: 'Status',
        inactive: 'Inactive',
        contact: 'Contact',
        management: 'Customer and Account Management',
        preferredLanguage: 'Preferred Language',
        messages: {
          updateSuccess: 'Customer updated successfully',
          createSuccess: 'Customer created successfully',
          emailSentSuccess: 'Welcome email sent',
          tempPasswordInfo: 'Temporary password: {password}',
          deleteSuccess: 'Customer deleted successfully',
          saveFailed: 'Failed to save customer',
          deleteFailed: 'Failed to delete customer',
          passwordResetSuccess: 'Password reset successfully',
          passwordResetFailed: 'Failed to reset password',
          passwordEmailedSuccess: 'New password sent to customer',
          resendSuccess: 'Welcome email sent to customer',
          resendFailed: 'Failed to send welcome email'
        },
        fullAccess: 'Full Access',
        fullAccessTooltip: 'Users with full access can view all content',
        resetPassword: {
          title: 'Reset Password',
          confirmation: 'Set a new password for {{name}}.',
          info: 'The new password will be saved and emailed to the customer.',
          newPasswordLabel: 'New password',
          confirmPasswordLabel: 'Confirm new password',
          passwordTooShort: 'Password must be at least 6 characters',
          passwordMismatch: 'Passwords do not match'
        },
        resendWelcome: {
          tooltip: 'Resend welcome email',
          title: 'Resend Welcome Email',
          confirmation: 'Resend the welcome email with the app download links to {{name}}?',
          info: 'The customer will receive the welcome email including the App Store and Google Play download links.',
          sendNewPasswordLabel: 'Also send a new password',
          sendNewPasswordHint: 'This resets the customer\'s current password. The new temporary password will be included in the email.',
          sendButton: 'Send'
        }
      },
      videos: {
        title: 'Videos',
        addVideo: 'Add Video',
        add: 'Add Video',
        edit: 'Edit Video',
        delete: 'Delete Video',
        confirmDeleteVideo: 'Are you sure you want to delete this video?',
        titleField: 'Title',
        description: 'Description',
        category: 'Category',
        allCategories: 'All Categories',
        duration: 'Duration',
        createdAt: 'Created',
        watch: 'Watch',
        portrait: 'Portrait video',
        vimeoForbidden: 'Vimeo blocks embedding for this video. Check its Privacy and Embed settings on Vimeo (set "Where can this be embedded" to Anywhere).',
        pdfs: 'PDF Files',
        addPdf: 'Add PDF',
        noPdfs: 'No PDFs attached',
        pdfUploading: 'Uploading…',
        confirmDeletePdf: 'Delete this PDF?',
        pdfsBlockingDelete: 'Delete the {{count}} attached PDF file(s) before deleting this video.',
        pdfsSaveFirst: 'Save the video first to attach PDF files.',
        published: 'Published',
        scheduled: 'Scheduled',
        views: 'Views',
        status: 'Status',
        type: 'Type',
        upload: 'Upload',
        active: 'Active',
        draft: 'Draft',
        unlisted: 'Unlisted',
        searchPlaceholder: 'Search videos...',
        noVideosFound: 'No videos found',
        noCategory: 'No category',
        allVideos: 'All Videos',
        analytics: 'Analytics',
        analyticsTitle: 'Analytics',
        analyticsComingSoon: 'Analytics will be added soon...',
        thumbnail: 'Thumbnail',
        video: 'video',
        isPublic: 'Public',
        isPublicTooltip: 'Public videos are visible to guest users'
      },
      stories: {
        title: 'Stories',
        add: 'Add Story',
        edit: 'Edit Story',
        delete: 'Delete Story',
        titleField: 'Title',
        description: 'Description',
        category: 'Category',
        duration: 'Duration',
        published: 'Published',
        scheduled: 'Scheduled',
        expiresAt: 'Expires At',
        mediaType: 'Media Type',
        image: 'Image',
        video: 'Video',
        story: 'story',
        thumbnail: 'Thumbnail',
        upload: 'Upload',
        storyFile: 'Story File',
        thumbnailFile: 'Thumbnail File',
        order: 'Order',
        scheduledAt: 'Scheduled At',
        titleEn: 'Title (English)',
        titleGr: 'Title (Greek)',
        descriptionEn: 'Description (English)',
        descriptionGr: 'Description (Greek)',
        confirmDelete: 'Are you sure you want to delete this story?',
        noStoriesFound: 'No stories found',
        searchPlaceholder: 'Search stories...',
        titleOptional: 'Optional - will auto-generate if empty',
        storyFileRequired: 'Story file is required',
        videoDurationMax: 'Video duration cannot exceed 20 seconds',
        videoDurationHelp: 'Video: 1-20 seconds',
        imageDurationHelp: 'Image: 3-10 seconds',
        scheduledHelp: 'Leave empty for immediate publish - Expires in 24 hours',
        storyFileHelp: 'Image or Video - Video max 20 seconds',
        imageStory: 'Image Story',
        videoStory: 'Video Story',
        uploadImage: 'Upload Image',
        uploadVideo: 'Upload Video',
        dragDropImage: 'Drag & drop image here or click to select',
        dragDropVideo: 'Drag & drop video here or click to select',
        imageFormats: 'JPG, PNG, GIF up to 10MB',
        videoFormats: 'MP4, WebM up to 50MB (max 20 seconds)',
        selectFile: 'Select File',
        fileSelected: 'File Selected',
        customThumbnail: 'Custom Thumbnail',
        selectThumbnail: 'Select Thumbnail',
        preview: 'Preview',
        autoGenerated: 'Auto-generated',
        thumbnailGenerationFailed: 'Failed to generate thumbnail',
        invalidFileType: 'Please select an image or video file',
        videoTooLarge: 'Video file too large. Please use a shorter video.',
        invalidThumbnailType: 'Thumbnail must be an image file',
        draft: 'Draft',
        expired: 'Expired',
        inactive: 'Inactive',
        mediaFormats: 'Supported: Images (JPG, PNG, GIF) up to 10MB, Videos (MP4, WebM) up to 50MB',
        selectedFile: 'Selected file',
        removeFile: 'Remove File',
        removeThumbnail: 'Remove Thumbnail',
        replaceMedia: 'Replace Media',
        uploadMedia: 'Upload Media',
        basicInfo: 'Basic Information',
        storyMedia: 'Story Media',
        reactivate: 'Reactivate',
        reactivateStory: 'Reactivate Story',
        confirmReactivate: 'Are you sure you want to reactivate this story? It will be visible in the app for another 24 hours.',
        originalExpiration: 'Original expiration',
        newExpiration: 'New expiration',
        showInactive: 'Show Inactive Stories',
        hideInactive: 'Hide Inactive Stories',
        errorReactivating: 'Error reactivating story. Please try again.',
        fileTooLarge: 'File is too large',
        videoShare: 'Video share',
        storyType: 'Story type',
        typeUpload: 'Upload media',
        typeVideoShare: 'Share an existing video',
        videoShareHelp: 'The story shows the video thumbnail and title. Tapping it opens the video — the video itself is not re-uploaded.',
        selectVideo: 'Select video',
        changeVideo: 'Change video',
        selectedVideo: 'Selected video',
        videoRequired: 'Please select a video to share',
        pickVideoTitle: 'Select a video',
        searchVideos: 'Search videos...',
        noVideosFound: 'No videos found',
        videoFetchError: 'Failed to load videos'
      },
      categories: {
        title: 'Categories',
        management: 'Category Management',
        manageCategoriesDesc: 'Manage application categories',
        add: 'Add Category',
        edit: 'Edit Category',
        delete: 'Delete Category',
        type: 'Category Type',
        typeVideo: 'Videos',
        typePdf: 'PDF Documents',
        pdfs: 'PDF Documents',
        addPdf: 'Add PDF',
        noPdfs: 'No PDF documents yet',
        pdfUploading: 'Uploading PDF...',
        confirmDeletePdf: 'Are you sure you want to delete this PDF?',
        pdfsSaveFirst: 'Save the category first to add PDF documents.',
        categoryIcon: 'Category Icon',
        categoryOrder: 'Category Order',
        isActive: 'Active',
        inactive: 'Inactive',
        activateCategory: 'Activate Category',
        deactivateCategory: 'Deactivate Category',
        dragToReorder: 'Drag to reorder',
        reorderCategories: 'Reorder Categories',
        categoryOrderUpdated: 'Category order updated',
        cannotDeleteCategoryWithContent: 'Cannot delete category with content',
        categoryHasVideos: 'Category has {count} videos',
        categoryHasStories: 'Category has {count} stories',
        removeContentFirst: 'Please remove all content first',
        confirmDeleteCategory: 'Are you sure you want to delete this category?',
        categoryDeleted: 'Category deleted successfully',
        categoryUpdated: 'Category updated successfully',
        categoryCreated: 'Category created successfully',
        categoryNameRequired: 'Category name is required',
        categoryRequired: 'Category is required',
        categoryIconRequired: 'Category icon is required',
        uploadIcon: 'Upload Icon',
        selectIcon: 'Select Icon',
        iconUploaded: 'Icon uploaded successfully',
        failedToUploadIcon: 'Failed to upload icon',
        chooseIconSource: 'Choose icon source',
        materialIcons: 'Material Icons',
        customIcon: 'Custom Icon',
        nameEn: 'Name (English)',
        nameGr: 'Name (Greek)',
        order: 'Order',
        status: 'Status',
        filterAll: 'All',
        filterActive: 'Active',
        filterInactive: 'Inactive',
        filterBy: 'Filter by',
        name: 'Name',
        icon: 'Icon',
        actions: 'Actions',
        noCategories: 'No categories found',
        uploadNewIcon: 'Upload New Icon',
        changeIcon: 'Change Icon',
        removeIcon: 'Remove Icon',
        iconPreview: 'Icon Preview',
        selectImage: 'Select Image',
        imageRequirements: 'PNG or JPG, max 2MB, recommended 256x256px',
        invalidFileType: 'Invalid file type. Please select an image file.',
        fileTooLarge: 'File too large. Maximum size is 2MB.',
        selectedFile: 'Selected file'
      },
      contact: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        firstName: 'First Name',
        lastName: 'Last Name',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        contactDetails: 'Contact Details',
        contactInformation: 'Contact Information',
        messageContent: 'Message Content',
        timestamps: 'Timestamps',
        noContacts: 'No contacts found',
        searchPlaceholder: 'Search by name, email, or subject...',
        filterByStatus: 'Filter by Status',
        deleteConfirmTitle: 'Delete Contact',
        deleteConfirmMessage: 'Are you sure you want to delete the contact from {name}? This action cannot be undone.',
        replyByEmail: 'Reply by Email',
        status: {
          label: 'Status',
          all: 'All',
          new: 'New',
          read: 'Read',
          responded: 'Responded',
          archived: 'Archived'
        },
        stats: {
          total: 'Total Contacts',
          new: 'New Messages',
          read: 'Read Messages',
          responded: 'Responded'
        }
      },
      success: {
        statusUpdated: 'Status updated successfully',
        contactDeleted: 'Contact deleted successfully'
      },
      error: {
        saveFailed: 'Failed to save',
        fetchContacts: 'Failed to fetch contacts',
        updateStatus: 'Failed to update status',
        deleteContact: 'Failed to delete contact'
      },
      common: {
        version: 'Version',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        confirm: 'Confirm',
        actions: 'Actions',
        status: 'Status',
        search: 'Search',
        loading: 'Loading...',
        saving: 'Saving...',
        sending: 'Sending...',
        create: 'Create',
        update: 'Update',
        greek: 'Greek',
        english: 'English',
        close: 'Close',
        all: 'All',
        page: 'Page',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        rowsPerPage: 'Rows per page',
        refresh: 'Refresh',
        seconds: 'seconds',
        optional: 'Optional',
        send: 'Send',
        edit: 'Edit',
        notAvailable: 'N/A'
      },
      admins: {
        title: 'Administrators',
        management: 'Admin Management',
        add: 'Add Admin',
        edit: 'Edit Admin',
        delete: 'Delete Admin',
        changePassword: 'Change Password',
        username: 'Username',
        email: 'Email',
        role: 'Role',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        lastLogin: 'Last Login',
        createdAt: 'Created At',
        actions: 'Actions',
        noAdmins: 'No administrators found',
        searchPlaceholder: 'Search by username or email...',
        filterByRole: 'Filter by Role',
        filterByStatus: 'Filter by Status',
        confirmDelete: 'Are you sure you want to delete this admin?',
        confirmDeleteTitle: 'Delete Administrator',
        passwordChanged: 'Password changed successfully',
        adminCreated: 'Administrator created successfully',
        adminUpdated: 'Administrator updated successfully',
        adminDeleted: 'Administrator deleted successfully',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        currentPassword: 'Current Password',
        passwordRequirements: 'Password must be at least 6 characters',
        passwordMismatch: 'Passwords do not match',
        changeOwnPassword: 'Change My Password',
        cannotDeleteSelf: 'You cannot delete your own account',
        cannotDeactivateSelf: 'You cannot deactivate your own account',
        cannotChangeOwnRole: 'You cannot change your own role',
        roles: {
          superadmin: 'Super Admin',
          admin: 'Admin',
          editor: 'Editor'
        }
      },
      settings: {
        title: 'Settings',
        appleComplianceMode: 'Apple Compliance Mode',
        appleComplianceModeDesc: 'When enabled, allows guest browsing and self-registration in the mobile app. Enable this for Apple App Store review, then disable after approval.',
        enabled: 'Enabled',
        disabled: 'Disabled',
        updateSuccess: 'Settings updated successfully',
        updateFailed: 'Failed to update settings',
        captureBlockingAlwaysOn: 'Screen capture blocking is always on',
        captureBlockingAlwaysOnDesc: 'Capture protection is always on in the mobile app and cannot be turned off from here. This is intentional: a remotely toggleable switch would fail open if the app could not reach the server, silently removing NDA protection. What it achieves differs by platform. On Android both screenshots and screen recording are blocked outright by the operating system. On iOS, Apple provides no way to block screenshots: screen recording and mirroring are detected and the content is hidden (so the recording is unusable), but a single screenshot cannot be prevented — only detected, logged and watermarked. The settings below are what make those screenshots traceable to a specific user.',
        captureReporting: 'Capture Attempt Logging',
        captureReportingDesc: 'Records detected screenshots and screen recordings against the user account. iOS only — on Android capture is blocked outright, so there is nothing to report.',
        pdfSharing: 'PDF Sharing',
        pdfSharingDesc: 'Shows the share button in the PDF viewer, which lets users send documents out via AirDrop, Mail or messaging apps. Screen protection cannot prevent this, so keep it off for NDA documents.',
        viewCaptureAttempts: 'View capture attempts',
        captureAttempts: 'Capture Attempts',
        captureAttemptsDesc: 'Detected screenshots and screen recordings, newest first. iOS only.',
        captureAttemptsFetchError: 'Failed to load capture attempts',
        noCaptureAttempts: 'No capture attempts recorded',
        allAttempts: 'All attempts',
        attemptDate: 'Date',
        attemptCustomer: 'User',
        attemptType: 'Type',
        attemptPlatform: 'Platform',
        attemptAppVersion: 'App version',
        attemptIp: 'IP address',
        guestAttempt: 'Guest',
        screenshot: 'Screenshot',
        screenRecording: 'Screen recording'
      },
      notifications: {
        title: 'Notifications',
        sendNotification: 'Send Notification',
        sendContentNotification: 'Send Content Notification',
        customNotification: 'Custom Notification',
        titleGr: 'Title (Greek)',
        titleEn: 'Title (English)',
        bodyGr: 'Body (Greek)',
        bodyEn: 'Body (English)',
        sendTo: 'Send To',
        sendToAll: 'Send to all users',
        sendToSpecificUser: 'Send to specific user',
        selectUser: 'Select User',
        titleRequired: 'Title is required in both languages',
        bodyRequired: 'Body is required in both languages',
        notificationSent: 'Notification sent successfully',
        sendError: 'Failed to send notification',
        contentNotificationInfo: 'Notify users about this {{type}}',
        sent: 'Sent',
        failed: 'Failed',
        noNotificationsFound: 'No notifications found',
        sentAt: 'Sent At',
        recipient: 'Recipient',
        allUsers: 'All Users',
        type: 'Type',
        newVideo: 'New Video',
        newStory: 'New Story',
        custom: 'Custom',
        announcement: 'Announcement',
        history: 'Notification History',
        totalSent: 'Total Sent',
        table: {
          type: 'Type',
          title: 'Title',
          body: 'Body',
          recipient: 'Recipient',
          date: 'Date'
        },
        types: {
          newVideo: 'New Video',
          newStory: 'New Story',
          custom: 'Custom'
        }
      },
      viewers: {
        modalTitleVideo: 'Video Viewers',
        modalTitleStory: 'Story Viewers',
        viewersButton: 'Views',
        watched: 'Watched',
        notWatched: 'Not watched',
        allViewers: 'All',
        statusFilter: 'Status',
        searchPlaceholder: 'Search by name or email...',
        noResults: 'No employees found',
        fullName: 'Full name',
        email: 'Email',
        status: 'Status',
        lastViewedAt: 'Last viewed at',
        watchPercentage: 'Watch %',
        completed: 'Completed',
        viewCount: 'Views',
        total: 'Total',
        watchedCount: 'Watched',
        notWatchedCount: 'Not watched',
        sendReminder: 'Send reminder',
        fetchError: 'Failed to load viewers'
      }
    }
  },
  gr: {
    translation: {
      login: {
        title: 'Σύνδεση Διαχειριστή',
        username: 'Όνομα χρήστη',
        password: 'Κωδικός',
        submit: 'Σύνδεση',
        error: 'Λάθος όνομα χρήστη ή κωδικός'
      },
      nav: {
        dashboard: 'Πίνακας Ελέγχου',
        videos: 'Βίντεο',
        stories: 'Ιστορίες',
        customers: 'Πελάτες',
        categories: 'Κατηγορίες',
        contacts: 'Επικοινωνία',
        admins: 'Διαχειριστές',
        logout: 'Αποσύνδεση'
      },
      dashboard: {
        title: 'Πίνακας Ελέγχου',
        overview: 'Επισκόπηση',
        statistics: 'Στατιστικά',
        totalUsers: 'Σύνολο Χρηστών',
        activeUsers: 'Ενεργοί Χρήστες',
        totalVideos: 'Σύνολο Βίντεο',
        activeVideos: 'Ενεργά Βίντεο',
        totalStories: 'Σύνολο Ιστοριών',
        activeStories: 'Ενεργές Ιστορίες',
        videoViews: 'Προβολές Βίντεο',
        storyViews: 'Προβολές Ιστοριών',
        categories: 'Κατηγορίες',
        notificationsSent: 'Ειδοποιήσεις που Στάλθηκαν',
        recentActivity: 'Πρόσφατη Δραστηριότητα',
        recentVideos: 'Πρόσφατα Βίντεο',
        recentStories: 'Πρόσφατες Ιστορίες',
        viewsOverTime: 'Προβολές ανά Χρόνο (Τελευταίες 30 Ημέρες)',
        contentByCategory: 'Περιεχόμενο ανά Κατηγορία',
        mostViewedVideos: 'Περισσότερο Προβαλλόμενα Βίντεο (Τελευταίες 7 Ημέρες)',
        last30Days: 'Τελευταίες 30 ημέρες',
        views: 'προβολές',
        noData: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
        loading: 'Φόρτωση πίνακα ελέγχου...'
      },
      navigation: {
        contacts: 'Επικοινωνία'
      },
      customers: {
        title: 'Πελάτες',
        add: 'Προσθήκη πελάτη',
        addCustomer: 'Προσθήκη πελάτη',
        editCustomer: 'Επεξεργασία πελάτη',
        edit: 'Επεξεργασία πελάτη',
        delete: 'Διαγραφή πελάτη',
        phone: 'Τηλέφωνο',
        email: 'Email',
        city: 'Πόλη',
        responsiblePerson: 'Υπεύθυνος',
        notes: 'Σημειώσεις',
        active: 'Ενεργός',
        firstName: 'Όνομα',
        lastName: 'Επώνυμο',
        phoneNumber: 'Αριθμός τηλεφώνου',
        emailAddress: 'Διεύθυνση email',
        personalInfo: 'Προσωπικά στοιχεία',
        contactInfo: 'Στοιχεία επικοινωνίας',
        additionalInfo: 'Επιπρόσθετες πληροφορίες',
        settings: 'Ρυθμίσεις',
        sendWelcomeEmail: 'Αποστολή email καλωσορίσματος με στοιχεία σύνδεσης',
        accountActive: 'Ενεργός λογαριασμός',
        tempPasswordInfo: 'Ένας προσωρινός κωδικός πρόσβασης θα δημιουργηθεί αυτόματα και θα σταλεί στη διεύθυνση email του πελάτη. Ο πελάτης μπορεί να αλλάξει αυτόν τον κωδικό μετά την πρώτη σύνδεση.',
        confirmDelete: 'Επιβεβαίωση διαγραφής',
        deleteConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον/την {name}; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
        noCustomersFound: 'Δεν βρέθηκαν πελάτες',
        name: 'Όνομα',
        status: 'Κατάσταση',
        inactive: 'Ανενεργός',
        contact: 'Επικοινωνία',
        management: 'Διαχείριση πελατών και λογαριασμών',
        preferredLanguage: 'Προτιμώμενη Γλώσσα',
        messages: {
          updateSuccess: 'Ο πελάτης ενημερώθηκε επιτυχώς',
          createSuccess: 'Ο πελάτης δημιουργήθηκε επιτυχώς',
          emailSentSuccess: 'Το email καλωσορίσματος στάλθηκε',
          tempPasswordInfo: 'Προσωρινός κωδικός: {password}',
          deleteSuccess: 'Ο πελάτης διαγράφηκε επιτυχώς',
          saveFailed: 'Αποτυχία αποθήκευσης πελάτη',
          deleteFailed: 'Αποτυχία διαγραφής πελάτη',
          passwordResetSuccess: 'Ο κωδικός επαναφέρθηκε επιτυχώς',
          passwordResetFailed: 'Αποτυχία επαναφοράς κωδικού',
          passwordEmailedSuccess: 'Ο νέος κωδικός στάλθηκε στον πελάτη',
          resendSuccess: 'Το email καλωσορίσματος στάλθηκε στον πελάτη',
          resendFailed: 'Αποτυχία αποστολής email καλωσορίσματος'
        },
        fullAccess: 'Πλήρης Πρόσβαση',
        fullAccessTooltip: 'Χρήστες με πλήρη πρόσβαση μπορούν να δουν όλο το περιεχόμενο',
        resetPassword: {
          title: 'Επαναφορά κωδικού',
          confirmation: 'Ορίστε νέο κωδικό για τον/την {{name}}.',
          info: 'Ο νέος κωδικός θα αποθηκευτεί και θα σταλεί στον πελάτη με email.',
          newPasswordLabel: 'Νέος κωδικός',
          confirmPasswordLabel: 'Επιβεβαίωση νέου κωδικού',
          passwordTooShort: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες',
          passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν'
        },
        resendWelcome: {
          tooltip: 'Επαναποστολή email καλωσορίσματος',
          title: 'Επαναποστολή Email Καλωσορίσματος',
          confirmation: 'Να σταλεί ξανά το email καλωσορίσματος με τους συνδέσμους λήψης της εφαρμογής στον/στην {{name}};',
          info: 'Ο πελάτης θα λάβει το email καλωσορίσματος με τους συνδέσμους λήψης για App Store και Google Play.',
          sendNewPasswordLabel: 'Αποστολή και νέου κωδικού',
          sendNewPasswordHint: 'Αυτό επαναφέρει τον τρέχοντα κωδικό του πελάτη. Ο νέος προσωρινός κωδικός θα περιληφθεί στο email.',
          sendButton: 'Αποστολή'
        }
      },
      videos: {
        title: 'Βίντεο',
        addVideo: 'Προσθήκη Βίντεο',
        add: 'Προσθήκη Βίντεο',
        edit: 'Επεξεργασία Βίντεο',
        delete: 'Διαγραφή Βίντεο',
        confirmDeleteVideo: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το βίντεο;',
        titleField: 'Τίτλος',
        description: 'Περιγραφή',
        category: 'Κατηγορία',
        allCategories: 'Όλες οι Κατηγορίες',
        duration: 'Διάρκεια',
        createdAt: 'Δημιουργήθηκε',
        watch: 'Παρακολούθηση',
        portrait: 'Κατακόρυφο βίντεο',
        vimeoForbidden: 'Το Vimeo δεν επιτρέπει την ενσωμάτωση αυτού του βίντεο. Ελέγξτε τις ρυθμίσεις Privacy και Embed στο Vimeo (ορίστε "Where can this be embedded" σε Anywhere).',
        pdfs: 'Αρχεία PDF',
        addPdf: 'Προσθήκη PDF',
        noPdfs: 'Δεν υπάρχουν συνημμένα PDF',
        pdfUploading: 'Μεταφόρτωση…',
        confirmDeletePdf: 'Διαγραφή αυτού του PDF;',
        pdfsBlockingDelete: 'Διαγράψτε πρώτα τα {{count}} συνημμένα αρχεία PDF πριν διαγράψετε το βίντεο.',
        pdfsSaveFirst: 'Αποθηκεύστε πρώτα το βίντεο για να προσθέσετε αρχεία PDF.',
        published: 'Δημοσιευμένο',
        scheduled: 'Προγραμματισμένο',
        views: 'Προβολές',
        status: 'Κατάσταση',
        type: 'Τύπος',
        upload: 'Μεταφόρτωση',
        active: 'Ενεργό',
        draft: 'Πρόχειρο',
        unlisted: 'Μη Εμφανές',
        searchPlaceholder: 'Αναζήτηση βίντεο...',
        noVideosFound: 'Δεν βρέθηκαν βίντεο',
        noCategory: 'Χωρίς κατηγορία',
        allVideos: 'Όλα τα Βίντεο',
        analytics: 'Αναλυτικά Στοιχεία',
        analyticsTitle: 'Αναλυτικά Στοιχεία',
        analyticsComingSoon: 'Τα αναλυτικά στοιχεία θα προστεθούν σύντομα...',
        thumbnail: 'Μικρογραφία',
        video: 'βίντεο',
        isPublic: 'Δημόσιο',
        isPublicTooltip: 'Τα δημόσια βίντεο είναι ορατά σε επισκέπτες'
      },
      stories: {
        title: 'Ιστορίες',
        add: 'Προσθήκη Ιστορίας',
        edit: 'Επεξεργασία Ιστορίας',
        delete: 'Διαγραφή Ιστορίας',
        titleField: 'Τίτλος',
        description: 'Περιγραφή',
        category: 'Κατηγορία',
        duration: 'Διάρκεια',
        published: 'Δημοσιευμένο',
        scheduled: 'Προγραμματισμένο',
        expiresAt: 'Λήγει στις',
        mediaType: 'Τύπος Μέσου',
        image: 'Εικόνα',
        video: 'Βίντεο',
        story: 'ιστορία',
        thumbnail: 'Μικρογραφία',
        upload: 'Μεταφόρτωση',
        storyFile: 'Αρχείο Ιστορίας',
        thumbnailFile: 'Αρχείο Μικρογραφίας',
        order: 'Σειρά',
        scheduledAt: 'Προγραμματισμένο Στις',
        titleEn: 'Τίτλος (Αγγλικά)',
        titleGr: 'Τίτλος (Ελληνικά)',
        descriptionEn: 'Περιγραφή (Αγγλικά)',
        descriptionGr: 'Περιγραφή (Ελληνικά)',
        confirmDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την ιστορία;',
        noStoriesFound: 'Δεν βρέθηκαν ιστορίες',
        searchPlaceholder: 'Αναζήτηση ιστοριών...',
        titleOptional: 'Προαιρετικό - θα δημιουργηθεί αυτόματα εάν είναι κενό',
        storyFileRequired: 'Το αρχείο ιστορίας είναι απαραίτητο',
        videoDurationMax: 'Η διάρκεια του βίντεο δεν μπορεί να υπερβαίνει τα 20 δευτερόλεπτα',
        videoDurationHelp: 'Βίντεο: 1-20 δευτερόλεπτα',
        imageDurationHelp: 'Εικόνα: 3-10 δευτερόλεπτα',
        scheduledHelp: 'Αφήστε κενό για άμεση δημοσίευση - Λήγει σε 24 ώρες',
        storyFileHelp: 'Εικόνα ή Βίντεο - Βίντεο μέχρι 20 δευτερόλεπτα',
        imageStory: 'Ιστορία Εικόνας',
        videoStory: 'Ιστορία Βίντεο',
        uploadImage: 'Μεταφόρτωση Εικόνας',
        uploadVideo: 'Μεταφόρτωση Βίντεο',
        dragDropImage: 'Σύρετε & αποθέστε εικόνα εδώ ή κάντε κλικ για επιλογή',
        dragDropVideo: 'Σύρετε & αποθέστε βίντεο εδώ ή κάντε κλικ για επιλογή',
        imageFormats: 'JPG, PNG, GIF έως 10MB',
        videoFormats: 'MP4, WebM έως 50MB (μέχρι 20 δευτερόλεπτα)',
        selectFile: 'Επιλογή Αρχείου',
        fileSelected: 'Αρχείο Επιλέχθηκε',
        customThumbnail: 'Προσαρμοσμένη Μικρογραφία',
        preview: 'Προεπισκόπηση',
        autoGenerated: 'Αυτόματα δημιουργημένη',
        thumbnailGenerationFailed: 'Αποτυχία δημιουργίας μικρογραφίας',
        selectThumbnail: 'Επιλογή Μικρογραφίας',
        invalidFileType: 'Παρακαλώ επιλέξτε αρχείο εικόνας ή βίντεο',
        videoTooLarge: 'Το αρχείο βίντεο είναι πολύ μεγάλο. Παρακαλώ χρησιμοποιήστε μικρότερο βίντεο.',
        invalidThumbnailType: 'Η μικρογραφία πρέπει να είναι αρχείο εικόνας',
        draft: 'Πρόχειρο',
        expired: 'Ληγμένο',
        inactive: 'Ανενεργό',
        mediaFormats: 'Υποστηρίζονται: Εικόνες (JPG, PNG, GIF) έως 10MB, Βίντεο (MP4, WebM) έως 50MB',
        selectedFile: 'Επιλεγμένο αρχείο',
        removeFile: 'Αφαίρεση Αρχείου',
        removeThumbnail: 'Αφαίρεση Μικρογραφίας',
        replaceMedia: 'Αντικατάσταση Μέσου',
        uploadMedia: 'Μεταφόρτωση Μέσου',
        basicInfo: 'Βασικές Πληροφορίες',
        storyMedia: 'Μέσο Ιστορίας',
        reactivate: 'Επανενεργοποίηση',
        reactivateStory: 'Επανενεργοποίηση Ιστορίας',
        confirmReactivate: 'Είστε σίγουροι ότι θέλετε να επανενεργοποιήσετε αυτή την ιστορία; Θα είναι ορατή στην εφαρμογή για άλλες 24 ώρες.',
        originalExpiration: 'Αρχική λήξη',
        newExpiration: 'Νέα λήξη',
        showInactive: 'Εμφάνιση Ανενεργών Ιστοριών',
        hideInactive: 'Απόκρυψη Ανενεργών Ιστοριών',
        errorReactivating: 'Σφάλμα κατά την επανενεργοποίηση της ιστορίας. Παρακαλώ δοκιμάστε ξανά.',
        fileTooLarge: 'Το αρχείο είναι πολύ μεγάλο',
        videoShare: 'Κοινοποίηση βίντεο',
        storyType: 'Τύπος ιστορίας',
        typeUpload: 'Μεταφόρτωση αρχείου',
        typeVideoShare: 'Κοινοποίηση υπάρχοντος βίντεο',
        videoShareHelp: 'Η ιστορία εμφανίζει τη μικρογραφία και τον τίτλο του βίντεο. Με το πάτημα ανοίγει το βίντεο — το ίδιο το βίντεο δεν ανεβαίνει ξανά.',
        selectVideo: 'Επιλογή βίντεο',
        changeVideo: 'Αλλαγή βίντεο',
        selectedVideo: 'Επιλεγμένο βίντεο',
        videoRequired: 'Παρακαλώ επιλέξτε ένα βίντεο για κοινοποίηση',
        pickVideoTitle: 'Επιλέξτε ένα βίντεο',
        searchVideos: 'Αναζήτηση βίντεο...',
        noVideosFound: 'Δεν βρέθηκαν βίντεο',
        videoFetchError: 'Αποτυχία φόρτωσης βίντεο'
      },
      categories: {
        title: 'Κατηγορίες',
        management: 'Διαχείριση Κατηγοριών',
        manageCategoriesDesc: 'Διαχειριστείτε τις κατηγορίες της εφαρμογής',
        add: 'Προσθήκη Κατηγορίας',
        edit: 'Επεξεργασία Κατηγορίας',
        delete: 'Διαγραφή Κατηγορίας',
        type: 'Τύπος Κατηγορίας',
        typeVideo: 'Βίντεο',
        typePdf: 'Έγγραφα PDF',
        pdfs: 'Έγγραφα PDF',
        addPdf: 'Προσθήκη PDF',
        noPdfs: 'Δεν υπάρχουν έγγραφα PDF ακόμη',
        pdfUploading: 'Μεταφόρτωση PDF...',
        confirmDeletePdf: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το PDF;',
        pdfsSaveFirst: 'Αποθηκεύστε πρώτα την κατηγορία για να προσθέσετε έγγραφα PDF.',
        categoryIcon: 'Εικονίδιο Κατηγορίας',
        categoryOrder: 'Σειρά Κατηγορίας',
        isActive: 'Ενεργή',
        inactive: 'Ανενεργή',
        activateCategory: 'Ενεργοποίηση Κατηγορίας',
        deactivateCategory: 'Απενεργοποίηση Κατηγορίας',
        dragToReorder: 'Σύρετε για αναδιάταξη',
        reorderCategories: 'Αναδιάταξη Κατηγοριών',
        categoryOrderUpdated: 'Η σειρά των κατηγοριών ενημερώθηκε',
        cannotDeleteCategoryWithContent: 'Δεν είναι δυνατή η διαγραφή κατηγορίας που περιέχει περιεχόμενο',
        categoryHasVideos: 'Η κατηγορία έχει {count} βίντεο',
        categoryHasStories: 'Η κατηγορία έχει {count} ιστορίες',
        removeContentFirst: 'Παρακαλώ αφαιρέστε πρώτα όλο το περιεχόμενο',
        confirmDeleteCategory: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την κατηγορία;',
        categoryDeleted: 'Η κατηγορία διαγράφηκε επιτυχώς',
        categoryUpdated: 'Η κατηγορία ενημερώθηκε επιτυχώς',
        categoryCreated: 'Η κατηγορία δημιουργήθηκε επιτυχώς',
        categoryNameRequired: 'Το όνομα της κατηγορίας είναι υποχρεωτικό',
        categoryRequired: 'Η κατηγορία είναι απαραίτητη',
        categoryIconRequired: 'Το εικονίδιο της κατηγορίας είναι υποχρεωτικό',
        uploadIcon: 'Μεταφόρτωση Εικονιδίου',
        selectIcon: 'Επιλογή Εικονιδίου',
        iconUploaded: 'Το εικονίδιο μεταφορτώθηκε επιτυχώς',
        failedToUploadIcon: 'Αποτυχία μεταφόρτωσης εικονιδίου',
        chooseIconSource: 'Επιλέξτε πηγή εικονιδίου',
        materialIcons: 'Material Icons',
        customIcon: 'Προσαρμοσμένο Εικονίδιο',
        nameEn: 'Όνομα (Αγγλικά)',
        nameGr: 'Όνομα (Ελληνικά)',
        order: 'Σειρά',
        status: 'Κατάσταση',
        filterAll: 'Όλες',
        filterActive: 'Ενεργές',
        filterInactive: 'Ανενεργές',
        filterBy: 'Φιλτράρισμα',
        name: 'Όνομα',
        icon: 'Εικονίδιο',
        actions: 'Ενέργειες',
        noCategories: 'Δεν βρέθηκαν κατηγορίες',
        uploadNewIcon: 'Μεταφόρτωση Νέου Εικονιδίου',
        changeIcon: 'Αλλαγή Εικονιδίου',
        removeIcon: 'Αφαίρεση Εικονιδίου',
        iconPreview: 'Προεπισκόπηση Εικονιδίου',
        selectImage: 'Επιλογή Εικόνας',
        imageRequirements: 'PNG ή JPG, μέγιστο 2MB, προτεινόμενο 256x256px',
        invalidFileType: 'Μη έγκυρος τύπος αρχείου. Παρακαλώ επιλέξτε αρχείο εικόνας.',
        fileTooLarge: 'Το αρχείο είναι πολύ μεγάλο. Μέγιστο μέγεθος 2MB.',
        selectedFile: 'Επιλεγμένο αρχείο'
      },
      contact: {
        name: 'Όνομα',
        email: 'Email',
        subject: 'Θέμα',
        message: 'Μήνυμα',
        firstName: 'Όνομα',
        lastName: 'Επώνυμο',
        createdAt: 'Δημιουργήθηκε',
        updatedAt: 'Ενημερώθηκε',
        contactDetails: 'Στοιχεία Επικοινωνίας',
        contactInformation: 'Πληροφορίες Επικοινωνίας',
        messageContent: 'Περιεχόμενο Μηνύματος',
        timestamps: 'Χρονικές Σημάνσεις',
        noContacts: 'Δεν βρέθηκαν επαφές',
        searchPlaceholder: 'Αναζήτηση με όνομα, email ή θέμα...',
        filterByStatus: 'Φιλτράρισμα με Κατάσταση',
        deleteConfirmTitle: 'Διαγραφή Επαφής',
        deleteConfirmMessage: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την επαφή από τον/την {name}; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
        replyByEmail: 'Απάντηση μέσω Email',
        status: {
          label: 'Κατάσταση',
          all: 'Όλες',
          new: 'Νέο',
          read: 'Αναγνωσμένο',
          responded: 'Απαντήθηκε',
          archived: 'Αρχειοθετημένο'
        },
        stats: {
          total: 'Συνολικές Επαφές',
          new: 'Νέα Μηνύματα',
          read: 'Αναγνωσμένα Μηνύματα',
          responded: 'Απαντημένα'
        }
      },
      success: {
        statusUpdated: 'Η κατάσταση ενημερώθηκε επιτυχώς',
        contactDeleted: 'Η επαφή διαγράφηκε επιτυχώς'
      },
      error: {
        saveFailed: 'Αποτυχία αποθήκευσης',
        fetchContacts: 'Αποτυχία φόρτωσης επαφών',
        updateStatus: 'Αποτυχία ενημέρωσης κατάστασης',
        deleteContact: 'Αποτυχία διαγραφής επαφής'
      },
      common: {
        version: 'Έκδοση',
        save: 'Αποθήκευση',
        cancel: 'Ακύρωση',
        delete: 'Διαγραφή',
        confirm: 'Επιβεβαίωση',
        actions: 'Ενέργειες',
        status: 'Κατάσταση',
        search: 'Αναζήτηση',
        loading: 'Φόρτωση...',
        saving: 'Αποθήκευση...',
        sending: 'Αποστολή...',
        create: 'Δημιουργία',
        update: 'Ενημέρωση',
        greek: 'Ελληνικά',
        english: 'Αγγλικά',
        close: 'Κλείσιμο',
        all: 'Όλες',
        page: 'Σελίδα',
        of: 'από',
        previous: 'Προηγούμενη',
        next: 'Επόμενη',
        rowsPerPage: 'Γραμμές ανά σελίδα',
        refresh: 'Ανανέωση',
        seconds: 'δευτερόλεπτα',
        optional: 'Προαιρετικό',
        send: 'Αποστολή',
        edit: 'Επεξεργασία',
        notAvailable: 'Μ/Δ'
      },
      admins: {
        title: 'Διαχειριστές',
        management: 'Διαχείριση Διαχειριστών',
        add: 'Προσθήκη Διαχειριστή',
        edit: 'Επεξεργασία Διαχειριστή',
        delete: 'Διαγραφή Διαχειριστή',
        changePassword: 'Αλλαγή Κωδικού',
        username: 'Όνομα χρήστη',
        email: 'Email',
        role: 'Ρόλος',
        status: 'Κατάσταση',
        active: 'Ενεργός',
        inactive: 'Ανενεργός',
        lastLogin: 'Τελευταία Σύνδεση',
        createdAt: 'Δημιουργήθηκε',
        actions: 'Ενέργειες',
        noAdmins: 'Δεν βρέθηκαν διαχειριστές',
        searchPlaceholder: 'Αναζήτηση με όνομα χρήστη ή email...',
        filterByRole: 'Φιλτράρισμα ανά Ρόλο',
        filterByStatus: 'Φιλτράρισμα ανά Κατάσταση',
        confirmDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον διαχειριστή;',
        confirmDeleteTitle: 'Διαγραφή Διαχειριστή',
        passwordChanged: 'Ο κωδικός άλλαξε επιτυχώς',
        adminCreated: 'Ο διαχειριστής δημιουργήθηκε επιτυχώς',
        adminUpdated: 'Ο διαχειριστής ενημερώθηκε επιτυχώς',
        adminDeleted: 'Ο διαχειριστής διαγράφηκε επιτυχώς',
        newPassword: 'Νέος Κωδικός',
        confirmNewPassword: 'Επιβεβαίωση Νέου Κωδικού',
        currentPassword: 'Τρέχων Κωδικός',
        passwordRequirements: 'Ο κωδικός πρέπει να είναι τουλάχιστον 6 χαρακτήρες',
        passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
        changeOwnPassword: 'Αλλαγή του Κωδικού μου',
        cannotDeleteSelf: 'Δεν μπορείτε να διαγράψετε τον δικό σας λογαριασμό',
        cannotDeactivateSelf: 'Δεν μπορείτε να απενεργοποιήσετε τον δικό σας λογαριασμό',
        cannotChangeOwnRole: 'Δεν μπορείτε να αλλάξετε τον δικό σας ρόλο',
        roles: {
          superadmin: 'Υπερδιαχειριστής',
          admin: 'Διαχειριστής',
          editor: 'Συντάκτης'
        }
      },
      settings: {
        title: 'Ρυθμίσεις',
        appleComplianceMode: 'Λειτουργία Συμμόρφωσης Apple',
        appleComplianceModeDesc: 'Όταν είναι ενεργοποιημένη, επιτρέπει την περιήγηση επισκεπτών και την αυτόματη εγγραφή στην εφαρμογή. Ενεργοποιήστε για την αξιολόγηση του App Store, απενεργοποιήστε μετά την έγκριση.',
        enabled: 'Ενεργοποιημένο',
        disabled: 'Απενεργοποιημένο',
        updateSuccess: 'Οι ρυθμίσεις ενημερώθηκαν επιτυχώς',
        updateFailed: 'Αποτυχία ενημέρωσης ρυθμίσεων',
        captureBlockingAlwaysOn: 'Η αποτροπή καταγραφής οθόνης είναι πάντα ενεργή',
        captureBlockingAlwaysOnDesc: 'Η προστασία από καταγραφή είναι πάντα ενεργή στην εφαρμογή και δεν μπορεί να απενεργοποιηθεί από εδώ. Αυτό είναι σκόπιμο: ένας διακόπτης που ελέγχεται από τον server θα έμενε ανοιχτός αν η εφαρμογή δεν μπορούσε να επικοινωνήσει, καταργώντας σιωπηλά την προστασία NDA. Το αποτέλεσμα διαφέρει ανά πλατφόρμα. Στο Android τόσο τα στιγμιότυπα όσο και η εγγραφή οθόνης αποκλείονται εξ ολοκλήρου από το λειτουργικό σύστημα. Στο iOS η Apple δεν παρέχει κανέναν τρόπο αποκλεισμού στιγμιότυπων: η εγγραφή και ο κατοπτρισμός οθόνης εντοπίζονται και το περιεχόμενο κρύβεται (ώστε η εγγραφή να είναι άχρηστη), αλλά ένα μεμονωμένο στιγμιότυπο δεν μπορεί να αποτραπεί — μόνο να εντοπιστεί, να καταγραφεί και να υδατογραφηθεί. Οι παρακάτω ρυθμίσεις είναι αυτές που καθιστούν τα στιγμιότυπα ιχνηλάσιμα σε συγκεκριμένο χρήστη.',
        captureReporting: 'Καταγραφή Απόπειρων Λήψης',
        captureReportingDesc: 'Καταγράφει τα εντοπισμένα στιγμιότυπα και εγγραφές οθόνης στον λογαριασμό του χρήστη. Μόνο για iOS — στο Android η λήψη αποκλείεται εξ ολοκλήρου, οπότε δεν υπάρχει τι να καταγραφεί.',
        pdfSharing: 'Κοινοποίηση PDF',
        pdfSharingDesc: 'Εμφανίζει το κουμπί κοινοποίησης στον προβολέα PDF, επιτρέποντας στους χρήστες να στέλνουν έγγραφα μέσω AirDrop, email ή εφαρμογών μηνυμάτων. Η προστασία οθόνης δεν μπορεί να το αποτρέψει, γι\' αυτό κρατήστε το απενεργοποιημένο για έγγραφα NDA.',
        viewCaptureAttempts: 'Προβολή απόπειρων λήψης',
        captureAttempts: 'Απόπειρες Λήψης',
        captureAttemptsDesc: 'Εντοπισμένα στιγμιότυπα και εγγραφές οθόνης, με τα πιο πρόσφατα πρώτα. Μόνο για iOS.',
        captureAttemptsFetchError: 'Αποτυχία φόρτωσης απόπειρων λήψης',
        noCaptureAttempts: 'Δεν έχουν καταγραφεί απόπειρες λήψης',
        allAttempts: 'Όλες οι απόπειρες',
        attemptDate: 'Ημερομηνία',
        attemptCustomer: 'Χρήστης',
        attemptType: 'Τύπος',
        attemptPlatform: 'Πλατφόρμα',
        attemptAppVersion: 'Έκδοση εφαρμογής',
        attemptIp: 'Διεύθυνση IP',
        guestAttempt: 'Επισκέπτης',
        screenshot: 'Στιγμιότυπο οθόνης',
        screenRecording: 'Εγγραφή οθόνης'
      },
      notifications: {
        title: 'Ειδοποιήσεις',
        sendNotification: 'Αποστολή Ειδοποίησης',
        sendContentNotification: 'Αποστολή Ειδοποίησης Περιεχομένου',
        customNotification: 'Προσαρμοσμένη Ειδοποίηση',
        titleGr: 'Τίτλος (Ελληνικά)',
        titleEn: 'Τίτλος (Αγγλικά)',
        bodyGr: 'Κείμενο (Ελληνικά)',
        bodyEn: 'Κείμενο (Αγγλικά)',
        sendTo: 'Αποστολή Σε',
        sendToAll: 'Αποστολή σε όλους τους χρήστες',
        sendToSpecificUser: 'Αποστολή σε συγκεκριμένο χρήστη',
        selectUser: 'Επιλογή Χρήστη',
        titleRequired: 'Ο τίτλος απαιτείται και στις δύο γλώσσες',
        bodyRequired: 'Το κείμενο απαιτείται και στις δύο γλώσσες',
        notificationSent: 'Η ειδοποίηση στάλθηκε επιτυχώς',
        sendError: 'Αποτυχία αποστολής ειδοποίησης',
        contentNotificationInfo: 'Ειδοποίηση χρηστών για αυτό το {{type}}',
        sent: 'Απεστάλη',
        failed: 'Αποτυχία',
        noNotificationsFound: 'Δεν βρέθηκαν ειδοποιήσεις',
        sentAt: 'Στάλθηκε Στις',
        recipient: 'Παραλήπτης',
        allUsers: 'Όλοι οι Χρήστες',
        type: 'Τύπος',
        newVideo: 'Νέο Βίντεο',
        newStory: 'Νέα Ιστορία',
        custom: 'Προσαρμοσμένη',
        announcement: 'Ανακοίνωση',
        history: 'Ιστορικό Ειδοποιήσεων',
        totalSent: 'Σύνολο Απεσταλμένων',
        table: {
          type: 'Τύπος',
          title: 'Τίτλος',
          body: 'Κείμενο',
          recipient: 'Παραλήπτης',
          date: 'Ημερομηνία'
        },
        types: {
          newVideo: 'Νέο Βίντεο',
          newStory: 'Νέα Ιστορία',
          custom: 'Προσαρμοσμένη'
        }
      },
      viewers: {
        modalTitleVideo: 'Θεατές Βίντεο',
        modalTitleStory: 'Θεατές Ιστορίας',
        viewersButton: 'Προβολές',
        watched: 'Έχει δει',
        notWatched: 'Δεν έχει δει',
        allViewers: 'Όλοι',
        statusFilter: 'Κατάσταση',
        searchPlaceholder: 'Αναζήτηση με όνομα ή email...',
        noResults: 'Δεν βρέθηκαν εργαζόμενοι',
        fullName: 'Ονοματεπώνυμο',
        email: 'Email',
        status: 'Κατάσταση',
        lastViewedAt: 'Τελευταία προβολή',
        watchPercentage: 'Ποσοστό προβολής',
        completed: 'Ολοκληρώθηκε',
        viewCount: 'Προβολές',
        total: 'Σύνολο',
        watchedCount: 'Έχουν δει',
        notWatchedCount: 'Δεν έχουν δει',
        sendReminder: 'Αποστολή υπενθύμισης',
        fetchError: 'Αποτυχία φόρτωσης θεατών'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'gr',
    fallbackLng: 'gr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;